// Panel "Prometeo": la vista de la EMPRESA cliente (contacto de RRHH). Vive bajo
// /company para no colisionar con /my-organization, que es la pantalla del colaborador.
const orgClientRoutes = {
  orgClientDashboard: {
    path: '/company'
  },
  orgClientWellbeing: {
    path: '/company/wellbeing'
  },
  orgClientDepartments: {
    path: '/company/departments'
  },
  orgClientMembers: {
    path: '/company/people'
  },
  orgClientReports: {
    path: '/company/reports'
  },
  orgClientPlans: {
    path: '/company/plans'
  }
};

export default orgClientRoutes;
